import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "../index.css"; 
import Select from "react-select";
import { SaveIcon, Search } from "lucide-react";
import config from "./config"; 
import { getProfileFromToken } from "./config"; 
import MHeader from "./header"; 
import Mfooter from "./footer";


function NewBimObj({ user }) { 

  const navigate = useNavigate();

  // --- Guardia per la rotta Admin ---
  useEffect(() => {
    let profile = getProfileFromToken();
    if (profile !== "Admin") {
      navigate("/");
    }
  }, [navigate]);
  
  // --- Stato per i campi del nuovo Oggetto BIM ---
  const [descrizione, setDescrizione] = useState('');
  const [bimid, setBimid] = useState('');
  const [categoria, setCategoria] = useState('');
  const [note, setNote] = useState('');

  // --- Stato per la Dropdown dei Luoghi ---
  const [luoghiOptions, setLuoghiOptions] = useState([]); // Per react-select
  const [selectedLuogo, setSelectedLuogo] = useState(null); // Per il valore scelto
  const [isLoading, setIsLoading] = useState(true); // Per feedback all'utente

  // --- Carica i luoghi per la dropdown all'avvio ---
  useEffect(() => {
       fetch(config.apiUrl+"/luogo")
      .then((res) => res.json())
      .then((data) => setLuoghiOptions(data))
      .catch((error) => console.error("Errore nel fetch dei luoghi:", error))
  }, []); // L'array vuoto [] significa "esegui solo al montaggio"


  // --- Gestione Invio Form ---
  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!selectedLuogo) {
      alert("Per favore, seleziona un luogo.");
      return;
    }

    const formData = new FormData();
    formData.append('descrizione', descrizione);
    formData.append('bimid', bimid);
    formData.append('categoria', categoria);
    formData.append('note', note);
    formData.append('id_luogo', selectedLuogo.value); // Invia l'ID (value) del luogo selezionato

    try {
      // Assumo un nuovo endpoint API per 'newbimobj'
      const response = await fetch(config.apiUrl + '/newbimobj', { 
        method: 'POST',
        headers: {
          "Authorization": "Bearer " + localStorage.getItem("token")
        },
        body: formData,
      });

      if (response.ok) {
        alert(`Oggetto caricato con successo!`);
        navigate("/"); // Ritorna alla home dopo il successo
      } else {
        alert('Errore durante il caricamento di Oggetto.'); // Corretto typo
      }
    } catch (error) {
      console.error('Errore:', error);
      alert('Si è verificato un errore durante il caricamento.');
    }
  };

  // Stili per il form (per rimpiazzare index.css)
  /*const styles = {
    app: { padding: '20px', maxWidth: '600px', margin: 'auto' },
    form: { display: 'flex', flexDirection: 'column', gap: '15px' },
    inputGroup: { display: 'flex', flexDirection: 'column' },
    label: { marginBottom: '5px', fontWeight: 'bold' },
    input: { padding: '8px', border: '1px solid #ccc', borderRadius: '4px' },
    textarea: { padding: '8px', border: '1px solid #ccc', borderRadius: '4px', minHeight: '80px' },
    button: { padding: '10px 15px', backgroundColor: '#007bff', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer' },
    smallText: { fontSize: '0.9rem', color: '#555' }
  };
*/
  return (
    <div className="App"> 
        <h2  className="App-header">{config.appName}</h2>
      <MHeader />
      <p ><small>utente: {user}</small></p>
      
      <h2>Aggiungi un nuovo Oggetto </h2>
      
      <form onSubmit={handleSubmit}>
        
        {/* Selezione Luogo */}
       

        <div>
          <label>Seleziona Luogo:</label><p></p>
            <Select
            options={luoghiOptions}
            value={selectedLuogo}
            onChange={setSelectedLuogo}
            placeholder="Seleziona un luogo..."
            isClearable
          />
        <Search  size={1} />

   
        </div>

        {/* Descrizione */}
         <div style={{ border: '1px solid #ccc', padding: '1rem', margin: '1rem 0', borderRadius: '8px' }}>
          <label >Descrizione:</label><p></p>
          <textarea
            value={descrizione}
            onChange={(e) => setDescrizione(e.target.value)}
            required
          />

        {/* BIM ID */}
          <p></p><label >ID (Codice):</label><p></p>
          <input
            type="text"
            value={bimid}
            onChange={(e) => setBimid(e.target.value)}
          />

        {/* Categoria */}
          <p></p><label >Categoria:</label><p></p>
          <input
          
            type="text"
            value={categoria}
            onChange={(e) => setCategoria(e.target.value)}
          />

        {/* Note */}
          <p></p><label>Note:</label><p></p>
          <textarea
            value={note}
            onChange={(e) => setNote(e.target.value)}
          /><p></p>
        
        <button type="submit" ><SaveIcon className="mr-2" /><br/>Salva Oggetto</button>
        </div>
      </form>
      
      <Mfooter/>
    </div>
  );
}
export default NewBimObj;
